import axios from 'axios';
import { getAccessTokenJWT } from 'utils/okta';
import { getExternalAccessTokenJWT } from 'utils/externalAccess';
import { appConfig } from 'config/appConfig';
import { getCountry } from 'utils/country';
import { setDateFormat } from 'utils/date';
import okta from 'constants/okta';
import paths from 'constants/paths';

export const getReport = ({ id, createdAt, workplace, terms }) => {
  const country = getCountry();
  const data = {
    assessmentId: id,
    country,
    workplace,
    createdat: setDateFormat(createdAt, country),
    terms,
  };

  return axios({
    method: 'post',
    url: appConfig.API_URL + `/${paths.report}/download`,
    responseType: 'arraybuffer',
    headers: {
      Authorization: okta.Bearer + getAccessTokenJWT(),
      'subscription-key': appConfig.API_SUBSCRIPTION_KEY,
      'Content-Type': 'application/json',
    },
    data,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      throw Error(error);
    });
};

export const getExternalClientReport = ({ id, createdAt, workplace, terms }, ExternalAccessKey) => {
  const country = getCountry();
  const data = {
    assessmentId: id,
    country,
    workplace,
    createdat: setDateFormat(createdAt, country),
    terms,
    ExternalAccessKey,
  };

  return axios({
    method: 'post',
    url: appConfig.API_URL + `/${paths.externalAccess}/${paths.report}`,
    responseType: 'arraybuffer',
    headers: {
      Authorization: okta.Bearer + getExternalAccessTokenJWT(),
      'subscription-key': appConfig.API_SUBSCRIPTION_KEY,
      'Content-Type': 'application/json',
    },
    data,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
      throw Error(error);
    });
};
